import { Icon } from '@blueprintjs/core';
import React from 'react';

import styles from './Avatar.module.scss';

type Props = {
  climber: Climber;
};

export default function Avatar({ climber }: Props) {
  return (
    <div className={styles.climberAvatar}>
      <Icon
        className={styles.climberIcon}
        icon="person"
        size={22}
        color="#37575c"
      />

      <span className={styles.climberNumber}>{climber.number}</span>

      <div className={styles.climberNameContainer}>
        <span className={styles.climberName}>{climber.name}</span>
      </div>
    </div>
  );
}
